// Value for the `Authorization` header of every admin-api call.
//   Admin login:  "Token <token>"  (the token from admin-login)
//   Outlet login: "<token>"        (the raw auth_token from outlet-login, no prefix)
// Returns null when nobody is logged in, so `if (!this.token)` guards keep working.
export const getAuthToken = () => {
  const token = localStorage.getItem('token');

  if (!token) return null;

  return localStorage.getItem('loginType') === 'admin' ? `Token ${token}` : token;
};

export default getAuthToken;
